import {
  DescriptionTab,
  //FeaturesTab,
  //ReviewsTab,
  SpecificationsTab,
} from "../index";
//import { features, reviews } from "@/utils/staticData/productDetails";

interface TabOption {
  label: string;
  component: React.ReactNode;
}

export const getTabOptions = (product: IProductDetails): TabOption[] => {
  if (!product) return [];

  const { name, longDescription, productImages, productOptions } = product;

  const tabOptions: TabOption[] = [
    {
      label: "Description",
      component: (
        <DescriptionTab
          title={name}
          description={longDescription}
          imageUrl={productImages[0].fullPath}
        />
      ),
    },
    {
      label: "Specifications",
      component: <SpecificationsTab specification={productOptions} />,
    }
    // {
    //   label: "Features",
    //   component: <FeaturesTab features={features} />,
    // },
    // // TODO: Temporarily hidden until full functionality will be added.
    // {
    //   label: `Reviews (${reviews.length})`,
    //   component: <ReviewsTab reviews={reviews} />,
    // },
  ];

  return tabOptions;
};
